import { useContext, useEffect } from "react";
import { Context } from "..";

export function useSelectedUser() {
  const { users } = useContext(Context)

  useEffect(() => {
    async function load() {
      const filters = localStorage.getItem('userStatus')
      if (filters !== null) {
        users.setUsersFilter(JSON.parse(filters))
        await users.loadList()
        users.loadSelectedUser()
      }
    }
    load()
  }, [])

}
